<template>
  <el-dialog class="editFormDialog" :title="$lang('编辑订单')" :modal-append-to-body="true" :visible.sync="dialogVisible" width="1000px" :show-close="false"
             :close-on-press-escape="false" :close-on-click-modal="false">
    <el-form :model="orderForm" :rules="rules" ref="editOrderForm" label-width="100px" label-position="top" class="demo-ruleForm">
      <p class="form-title">{{ $lang('寄件人信息') }}</p>
      <div class="form-box">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$lang('寄件人姓名')" prop="senderName">
              <el-input v-model="orderForm.senderName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('寄件人手机号')" prop="senderMobilePhone">
              <el-input v-model="orderForm.senderMobilePhone" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('发件州')" prop="senderProvinceName">
              <el-input v-model="orderForm.senderProvinceName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('寄件城市')" prop="senderCityName">
              <el-input v-model="orderForm.senderCityName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$lang('寄件街道')" prop="senderStreet">
              <el-input v-model="orderForm.senderStreet" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('寄件详细地址')" prop="senderDetailedAddress">
              <el-input v-model="orderForm.senderDetailedAddress" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <p class="form-title">{{ $lang('收件人信息') }}</p>
      <div class="form-box">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$lang('收件邮编')" prop="receiverPostalCode">
              <el-input v-model="orderForm.receiverPostalCode" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$lang('收件人姓名')" prop="receiverName">
              <el-input v-model="orderForm.receiverName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('收件人手机号')" prop="receiverMobilePhone">
              <el-input v-model="orderForm.receiverMobilePhone" @input="orderForm.receiverMobilePhone = orderForm.receiverMobilePhone.replace(/[^0-9+]/g, '')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('收件州')" prop="receiverProvinceName">
              <el-input v-model="orderForm.receiverProvinceName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('收件城市')" prop="receiverCityName">
              <el-input v-model="orderForm.receiverCityName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$lang('收件街道')" prop="receiverStreet">
              <el-input v-model="orderForm.receiverStreet" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('收件详细地址')" prop="receiverDetailedAddress">
              <el-input v-model="orderForm.receiverDetailedAddress"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <p class="form-title">{{ $lang('货物信息') }}</p>
      <div class="form-box">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$lang('物品类型')" prop="goodsTypeName">
              <el-input v-model="orderForm.goodsTypeName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('物品名称')" prop="goodsName">
              <el-input v-model="orderForm.goodsName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('物品重量(kg)')" prop="packageTotalWeight">
              <el-input v-model="orderForm.packageTotalWeight" @input="orderForm.packageTotalWeight = orderForm.packageTotalWeight.replace(/[^\d.]/g, '')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('产品类型')" prop="expressTypeName">
              <el-input v-model="orderForm.expressTypeName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$lang('结算方式')" prop="paymentModeName">
              <el-input v-model="orderForm.paymentModeName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('代收货款金额')" prop="codMoney">
              <el-input v-model="orderForm.codMoney" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('代收货款币别名称')" prop="codCurrencyTypeName">
              <el-input v-model="orderForm.codCurrencyTypeName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeEdit">{{ $lang('取消') }}</el-button>
      <el-button type="primary" @click="saveEdit">{{ $lang('保存') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    const tenNumber = (rule, value, callback) => {
      if (value && value.length <= 13 && value.length >= 10) {
        callback()
      } else {
        callback(new Error(this.$lang('请输入10到13位数字')))
      }
    }
    const packageWeight = (rule, value, callback) => {
      if (value && Number(value) < 0.01) {
        callback(new Error(this.$lang('请输入大于0.01')))
      } else {
        callback()
      }
    }
    return {
      orderForm: {
        senderName: '', // 寄件人姓名
        senderMobilePhone: '', // 寄件人手机号
        senderProvinceName: '', // 发件州
        senderCityName: '', // 寄件城市
        senderStreet: '', // 寄件街道
        senderDetailedAddress: '', // 寄件详细地址
        receiverPostalCode: '', // 收件邮编
        receiverName: '', // 收件人姓名
        receiverMobilePhone: '', // 收件人手机号
        receiverProvinceName: '', // 收件州
        receiverCityName: '', // 收件城市
        receiverStreet: '', // 收件街道
        receiverDetailedAddress: '', // 收件详细地址
        goodsTypeName: '', // 物品类型
        goodsName: '', // 物品名称
        packageTotalWeight: '', // 物品重量
        expressTypeName: '', // 产品类型
        paymentModeName: '', // 结算方式
        codMoney: '', // 代收货款金额
        codCurrencyTypeName: '' // 代收货款币别名称
      },
      rules: {
        receiverName: [{ required: true, message: this.$lang('请输入收件人姓名'), trigger: ['blur', 'change'] }],
        receiverMobilePhone: [{ required: true, message: this.$lang('请输入收件人手机号'), trigger: ['blur', 'change'] }, { validator: tenNumber, trigger: ['blur', 'change'] }],
        receiverDetailedAddress: [{ required: true, message: this.$lang('请输入收件详细地址'), trigger: ['blur', 'change'] }],
        goodsName: [{ required: true, message: this.$lang('请输入物品名称'), trigger: ['blur', 'change'] }],
        packageTotalWeight: [{ required: true, message: this.$lang('请输入物品重量'), trigger: ['blur', 'change'] }, { validator: packageWeight, trigger: ['blur', 'change'] }]
      }
    }
  },
  watch: {
    rowData: {
      deep: true,
      immediate: true,
      handler(v) {
        this.orderForm = JSON.parse(JSON.stringify(v))
        if (!this.orderForm.packageTotalWeight) this.orderForm.packageTotalWeight = '0.01'
      }
    }
  },
  methods: {
    shopifyAddr() {
      this.$emit('showShopAddr', { orderStatusCode: this.orderForm.orderStatusCode, customerOrderId: this.orderForm.customerOrderId })
    },
    saveEdit() {
      this.$refs['editOrderForm'].validate((valida) => {
        if (valida) {
          const temp = JSON.parse(JSON.stringify(this.orderForm))
          if (temp.errorList) {
            delete temp.errorList
          }
          this.$emit('save', temp)
          this.closeEdit()
        }
      })
    },
    closeEdit() {
      this.$emit('update:dialogVisible', false)
    }
  }
}
</script>
<style lang="scss">
.editFormDialog {
  .form-title {
    font-size: 18px;
    font-weight: bold;
  }
  .form-box {
    background-color: #f8f7f8;
    border-radius: 16px;
    padding: 10px 16px;
    //.el-form-item {
    //  margin-bottom: 10px !important;
    //}
    .el-form-item__label {
      padding: 0!important;
    }
    .senderBtn {
      color: #E60000;
      //height: 92px;
      //line-height: 120px;
      margin-top: 45px;
      display: flex;
      justify-content: flex-end;
      margin-right: 50px;
      i:hover, span:hover {
        cursor: pointer;
      }
    }
  }
  .el-dialog__body {
    height: 400px;
    overflow: auto;
  }
  .el-dialog__footer {
    text-align: center !important;
  }
}
</style>
